import { BOTTOM } from 'app/analytics/constants/positions';
import { actionDetail } from 'app/analytics/helpers';
import { commonActionDetail } from 'app/analytics/selectors';
import { LOCALE_MAP } from 'app/features/localization/constants';
import { LANGUAGE_SELECTED } from 'app/features/localization/actionTypes';
import {
  PRIVACY_SELECTED,
  TERMS_OF_SERVICE_SELECTED,
} from 'app/features/footer/actionTypes';
import translations from 'app/features/localization/translations.json';

const footer = {
  [TERMS_OF_SERVICE_SELECTED]: getState => ({
    type: 'track',
    name: 'Terms Selected',
    properties: actionDetail({
      position: BOTTOM,
      textOfButtonOrLink: translations.footer_tos,
      ...commonActionDetail(getState()),
    }),
  }),
  [PRIVACY_SELECTED]: getState => ({
    type: 'track',
    name: 'Privacy Selected',
    properties: actionDetail({
      position: BOTTOM,
      textOfButtonOrLink: translations.footer_privacy_policy,
      ...commonActionDetail(getState()),
    }),
  }),
  [LANGUAGE_SELECTED]: (getState, { payload: locale }) => ({
    type: 'track',
    name: 'Localization Language Selected',
    properties: {
      ...actionDetail({
        position: BOTTOM,
        textOfButtonOrLink: LOCALE_MAP[locale],
        ...commonActionDetail(getState()),
      }),
      localizationLanguage: locale,
    },
  }),
};

export default footer;
